module.exports = __webpack_public_path__ + "static/media/grph-stat2-89.11e3f8ec.svg";